import React, { useState } from 'react';
import { FaInfoCircle, FaTimes } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { dismissBanner } from '../store/slices/uiSlice';

interface InfoBannerProps {
    id: string;
    children: React.ReactNode;
    style?: React.CSSProperties;
    iconColor?: string;
}

const InfoBanner: React.FC<InfoBannerProps> = ({ id, children, style, iconColor = 'var(--accent)' }) => {
    const dispatch = useDispatch();
    const dismissedBanners = useSelector((state: RootState) => state.ui.dismissedBanners);
    const [isHovered, setIsHovered] = useState(false);

    if (dismissedBanners.includes(id)) {
        return null;
    }

    const handleDismiss = () => {
        dispatch(dismissBanner(id));
    };

    return (
        <div className="info-banner" style={{
            marginTop: '1rem',
            padding: '0.75rem 1rem',
            backgroundColor: 'var(--bg-elevated)',
            border: '1px solid var(--border)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            fontSize: '0.9rem',
            color: 'var(--text-muted)',
            ...style
        }}>
            <FaInfoCircle style={{ color: iconColor, fontSize: '1.1rem', flexShrink: 0 }} />
            <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap' }}>{children}</div>
            <button 
                onClick={handleDismiss}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: isHovered ? '#64748b' : '#94a3b8',
                    transition: 'color 0.2s',
                    marginLeft: 'auto'
                }}
                title="Dismiss"
            >
                <FaTimes />
            </button>
        </div>
    );
};

export default InfoBanner;
